// voyageStatusUtils.js
import React from 'react';
import { Chip } from '@mui/material';

/**
 * Returns a MUI Chip representing voyage status based on ETD, ETA and cancelled flag.
 * Replaces the inline getStatusChip previously in VoyageWidget.js so it can be reused.
 *
 * @param {string|Date} actualETD
 * @param {string|Date} actualETA
 * @param {boolean} cancelled
 * @param {number|null} [effectiveShipped]
 * @returns {JSX.Element|null}
 */
export const getVoyageStatusLabel = (
  actualETD,
  actualETA,
  cancelled,
  effectiveShipped
) => {
  if (cancelled === true) return 'Cancelled';
  const currentDate = new Date();
  const etdDate = new Date(actualETD);
  const etaDate = actualETA ? new Date(actualETA) : null;

  if (isNaN(etdDate)) return 'Invalid ETD';
  if (currentDate < etdDate && Number(effectiveShipped) > 0) return 'Loading';
  if (!etaDate) return 'No ETA info';
  if (currentDate < etdDate) return 'Planned';
  if (currentDate >= etdDate && currentDate < etaDate) return 'In Transit';
  if (currentDate >= etaDate) return 'Arrived';
  return null;
};

export const VOYAGE_STATUS_OPTIONS = [
  'Planned',
  'Loading',
  'In Transit',
  'Arrived',
  'Cancelled',
  'No ETA info',
  'Invalid ETD',
];

export const getVoyageStatusChip = (
  actualETD,
  actualETA,
  cancelled,
  effectiveShipped
) => {
  const label = getVoyageStatusLabel(
    actualETD,
    actualETA,
    cancelled,
    effectiveShipped
  );
  if (!label) return null;
  const colorMap = {
    Cancelled: 'error',
    'Invalid ETD': 'error',
    Planned: 'info',
    Loading: 'secondary',
    'In Transit': 'warning',
    Arrived: 'success',
  };
  return <Chip label={label} color={colorMap[label] || 'default'} />;
};

export default getVoyageStatusChip;
